import './InnerLayout.css'
import logo from './../../images/logo.png'
import dashboardIcon from './../../images/icons/dashboard_icon.svg';
import campaignsIcon from './../../images/icons/campaigns_icon.svg';
import channelsIcon from './../../images/icons/channels_icon.svg';
import meidiaIcon from './../../images/icons/media_icon.svg';
import playerIcon from './../../images/icons/player_icon.svg';
import reportsIcon from './../../images/icons/reports_icon.svg';
import calendarIcon from './../../images/icons/calendar_icon.svg';
import userIcon from './../../images/icons/user_icon.svg';
import mosaicIcon from './../../images/icons/mosaic_icon.svg';
import settingsIcon from "../../images/icons/settings_icon.svg";
import monitoringIcon from "../../images/icons/monitoring_icon.svg";
import { RouteComponentProps, withRouter } from 'react-router';
import Header from '../../components/header/Header';
import { fireBodyClick } from '../../../services/globalEventHandler';
import { currentUserHasPermission, Permission } from '../../../api/authApi';
import { NewAlertMessage, useAlertsCountStore } from '../../../hooks/useSystemAlerts';
import { useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { SeverityType } from '../../../api/alertsApi';
import { Routes } from '../../../constants/routes';
import { GlobalErrorModal } from '../../components/sideModal/Modal';
import ProgressBarGlobal from '../../components/progressBar/ProgressBarGlobal';

export type NavigationTabs = "dashboard" |
                             "campaigns" | 
                             "channels" | 
                             "media" | 
                             "players" |
                             "reports" | 
                             'priorityList' | 
                             'users' | 
                             'userSettings' | 
                             'playNowList' | 
                             'skins' | 
                             'settings' | 
                             "monitoring" |
                             'tvGuide' |
                             'none';

interface InnerLayoutProps extends RouteComponentProps<any> {
    children? : JSX.Element,
    activeTab: NavigationTabs,
    logOut: () => void,
    toogleCollapse : () => void,
    isCollapsed: boolean,
}

const InnerLayout = (props: InnerLayoutProps) => {

    let counter = useAlertsCountStore()

    useEffect(()=> {
        counter.start();
        counter.resetIsShown();
        return () => {
            counter.pause()
        }
    },[])

    useEffect(()=>{
        showToastNewMessages(counter.messages)
    },[counter.messages])

    const showToastNewMessages = ( newMessages: NewAlertMessage[]) => {
        newMessages.forEach( it => showToastBySeverityType(it))
    }

    const showToastBySeverityType = ( newMessage: NewAlertMessage) => {
        if(counter.isShow(newMessage.id)){
            switch (newMessage.severity) {
                case SeverityType.Info : {
                    toast.info(newMessage.message, {
                        onClick: () => {counter.removeMessage(newMessage.id)},
                        onClose: () => {counter.removeMessage(newMessage.id)}
                    });
                    break;
                }
                case SeverityType.Warning : {
                    toast.warning(newMessage.message,{
                        onClick: () => {counter.removeMessage(newMessage.id)},
                        onClose: () => {counter.removeMessage(newMessage.id)}
                    });
                    break;
                }
                case SeverityType.Important : {
                    toast.error(newMessage.message, {
                        onClick: () => {counter.removeMessage(newMessage.id)},
                        onClose: () => {counter.removeMessage(newMessage.id)}
                    });
                    break;
                }
            }

            counter.onShow(newMessage.id)
        }
    }

    const getActiveTabIndex  = (tab: NavigationTabs) => {
        switch(tab){
            case 'dashboard': return 1;
            case 'media' : return 2;
            case 'campaigns' : return 3;
            case 'channels' : return 4;
            case 'reports' : return 5;
            case 'priorityList': return 6;
            case 'users': return 7;
            case 'playNowList': return 8;
            case 'players' : return 9;
            case 'userSettings': return 10;
            case 'skins': return 11;
            case 'settings': return 12;
            case 'monitoring' : return 13;
            case 'tvGuide' : return 14;
            case 'none': return 0;
        }
    }

    const getNavigationItemDispayType = (index: number, activeIndex: number): DisplayType | undefined => {
        var diff = index - activeIndex;
        if(diff == -1) return "overActive";
        if(diff == 0) return "active";
        if(diff == 1) return "underActive";
    }

    const goTo = (tab : NavigationTabs) => {
        props.history.push(`/${tab}`);
    }

    const activeTabIndex = getActiveTabIndex(props.activeTab);
    const classMenu = `inner_layout_wrapper ${props.isCollapsed ? "collapsed" : ""}`
    return  <div className={classMenu} onClick={fireBodyClick}>
                <div className="left_column_layout">
                    <div className="logo">
                        <img src={logo} />
                    </div>
                    <div className="nav-items-wrapper">
                        <EmptyNavigationElement displayType={getNavigationItemDispayType(0, activeTabIndex)}/>
                        <NavigationElement permissions={[Permission.Dashboard]} text="Dashboard" icon={dashboardIcon} displayType={getNavigationItemDispayType(1, activeTabIndex)} onClick={() => goTo('dashboard')}/>
                        <NavigationElement permissions={[Permission.Campaigns, Permission.ExternalOrganisationUser]} text="Campaigns" icon={campaignsIcon} displayType={getNavigationItemDispayType(3, activeTabIndex)} onClick={() => goTo('campaigns')}/>
                        <NavigationElement permissions={[Permission.Media, Permission.ExternalOrganisationUser]} text="Media" icon={meidiaIcon} displayType={getNavigationItemDispayType(2, activeTabIndex)} onClick={() => goTo('media')}/>
                        <NavigationElement permissions={[Permission.Channels, Permission.ExternalOrganisationUser]} text="Networks" icon={channelsIcon} displayType={getNavigationItemDispayType(4, activeTabIndex)} onClick={() => goTo('channels')}/>
                        <NavigationElement permissions={[Permission.PriorityList]} text="Streaming" icon={calendarIcon} displayType={getNavigationItemDispayType(6, activeTabIndex)} onClick={() => goTo('priorityList')}/>
                        <NavigationElement permissions={[Permission.PlayNowList]} text="Play Now" icon={calendarIcon} displayType={getNavigationItemDispayType(8, activeTabIndex)} onClick={() => goTo('playNowList')}/>
                        <NavigationElement permissions={[Permission.MosaicScreen]} text="Skins" icon={mosaicIcon} displayType={getNavigationItemDispayType(11, activeTabIndex)} onClick={() => goTo('skins')}/>
                        <NavigationElement permissions={[Permission.Players]} text="Players" icon={playerIcon} displayType={getNavigationItemDispayType(9, activeTabIndex)} onClick={() => goTo('players')}/>
                        <NavigationElement permissions={[Permission.Reports]} text="Reports" icon={reportsIcon} displayType={getNavigationItemDispayType(5, activeTabIndex)} onClick={() => goTo('reports')}/>
                        <NavigationElement permissions={[Permission.PriorityList]} text="TV Guide" icon={monitoringIcon} displayType={getNavigationItemDispayType(14, activeTabIndex)} onClick={() => goTo('tvGuide')}/>
                        <NavigationElement permissions={[Permission.Players]} text="Monitoring" icon={monitoringIcon} displayType={getNavigationItemDispayType(13, activeTabIndex)} onClick={() => goTo('monitoring')}/>
                        <NavigationElement permissions={[Permission.Settings]} text="Settings" tooltip={counter.totalAlerts} icon={settingsIcon} displayType={getNavigationItemDispayType(12, activeTabIndex)} onClick={() => goTo('settings')}/>
                        <NavigationElement permissions={[Permission.Users]} text="Users" icon={userIcon} displayType={getNavigationItemDispayType(7, activeTabIndex)} onClick={() => goTo('users')}/>
                        <EmptyNavigationElement displayType={getNavigationItemDispayType(12, activeTabIndex)} />
                    </div>

                    <div className="collapse-position">
                        <a href={Routes.ChangeLog} className='version'><span>Update date:</span> 14.07.2026</a>
                         <button className="collapse-button" onClick={props.toogleCollapse}> 
                            <span className="collapse-icon">&#x2770;&#x2770;</span> 
                            <span className="collapse-text">Collapse</span>
                        </button>
                    </div>
                </div>
                <div className="right_column_layout">
                    <Header logOut={props.logOut}/>
                    <div className="container">
                        {props.children}
                    </div>   

                    <ToastContainer 
                        autoClose={false}
                        newestOnTop
                        closeOnClick
                        theme="colored"
                    />   

                    <ProgressBarGlobal />
                    <GlobalErrorModal />            
                </div>
            </div>
}

type DisplayType = "active" | "overActive" | "underActive";

type NavigationElementProps = 
{
    text : string;
    icon : string;
    tooltip? : number,
    displayType? : DisplayType;
    onClick: () => void;
    permissions: Permission[];
}



const NavigationElement = (props : NavigationElementProps) => {

    var anyPermission = props.permissions.find(p => currentUserHasPermission(p));

    if(!anyPermission) {
        return <></>;
    }
    const className = `navigation_menu_item ${props.displayType}`;  
    

    if(props.displayType == "active"){
        return<>
                <div className="nav-active-background" onClick={props.onClick}>
                    <div className={className}>
                        <img src={props.icon}></img><span className="nav-text"> <>
                            {props.text} &nbsp;
                            {!!props.tooltip && props.text === "Settings" ? <span className='alert-tooltip'>{props.tooltip}</span> : null}
                            </>
                        </span>
                        <span className="deco-active-top"><span></span></span>
                        <span className="deco-active-bottom"><span></span></span>
                    </div>    
                </div>              
            </>
    }
    else{
        return<>
            <div className={className} onClick={props.onClick}>
                <img src={props.icon}></img><span className="nav-text"> <>
                    {props.text} &nbsp;
                    {!!props.tooltip ? <span className='alert-tooltip'>{props.tooltip}</span> : null}
                    </>
                </span>
            </div>    
        </>
    }
  
}

type EmptyNavigationElementProps = {
    displayType? : DisplayType;
}

function EmptyNavigationElement(props : EmptyNavigationElementProps){
    const className = `empty_navigation_menu_item ${props.displayType}`;   
    return <div className={className}></div>
}

export default withRouter(InnerLayout)
